module.exports = __webpack_public_path__ + "img/3.61d29bb1.jpg";